import { Model } from '@appstrax/services/database';

export type HistoryEntryKind =
  | 'info'
  | 'user'
  | 'assistant'
  | 'update'
  | 'error';

/**
 * A single history line for a specific UI scope.
 * Scope keys should be stable and unique per panel:
 * - define.chat
 * - define.definition
 * - tickets.chat
 * - tickets.board
 */
export class HistoryEntry extends Model {
  public projectId: string = '';
  public scopeKey: string = '';
  public kind: HistoryEntryKind = 'info';
  public text: string = '';
  public timestamp: number = Date.now();
  // Keep non-null to avoid mapper issues with nested assignment.
  public meta: any = {};
}

